import { Field } from 'api/tasks';
import { IntegrationConfig } from '../types';

export enum MappingMechanism {
  Automatic = 'AUTOMATIC',
  PromptDuringProjectcreation = 'PROMPT_DURING_PROJECT_CREATION',
  PromptDuringIssuecreation = 'PROMPT_DURING_ISSUE_CREATION',
  Fixed = 'FIXED',
}

export type Option = {
  label: string;
  valueStr: string;
  active?: boolean;
  value?: string;
  integrationFieldId?: string;
};

export type JiraIssueType = {
  id: string;
  name: string;
};

export type MetaFieldValue = {
  id: string;
  name: string;
  iconUrl?: string;
  description?: string;
  self?: string;
  subtask?: boolean;
  avatarId?: number;
  entityId?: string;
  hierarchyLevel?: number;
  displayName?: string;
};

export interface JiraField extends Omit<Field, 'fieldId' | 'metaData'> {
  integrationFieldId: string;
  required?: boolean;
  fieldValue?: string;
  metaData?: {
    options: Option[];
    rangeAvailable?: boolean;
    range?: {
      min?: number;
      max?: number;
    };
    default?: any;
  };
  metaFieldValue?: MetaFieldValue;
}

export type JiraProject = {
  id: string;
  key: string;
  name?: string;
  url?: string;
  type: string;
  fields: JiraField[];
};

export enum ProjectMappingMechanism {
  Fixed = 'FIXED',
  PromptDuringIssueCreation = 'PROMPT_DURING_ISSUE_CREATION',
}

export type JiraRLTaskStatusMapping = {
  jiraIssuePattern: string;
  rlStatusValue: number;
};

export type SettingsMeta = {
  syncTaskStatusField: boolean;
  syncTaskComments: boolean;
  epicMappingMechanism: MappingMechanism;
  issueTaskStatusMappings?: JiraRLTaskStatusMapping[];
  jiraIssueType: string;
  fixedProjectId: string;
  fixedEpicId?: string;
  defaultIssueTypeId?: string;
  fields: JiraField[];
  fixedEpicIssueTypeId?: string;
  projectMappingMechanism: ProjectMappingMechanism;
};

export type JiraIssue = {
  id: string;
  key: string;
  url: string;
  type: string;
  fields: JiraField[];
};

export type JiraEpic = {
  id: string;
  key: string;
  name: string;
  url: string;
  type: string;
};

export type JiraConfig = IntegrationConfig<SettingsMeta>;

export enum SourceType {
  Templates = 'TEMPLATE',
}

export enum ValidationError {
  IntegrationBadState = 'INTEGRATION_SETTINGS_BAD_STATE',
}

export type ProjectValidationResponse = {
  code: ValidationError;
  reason: string;
  resourceType: SourceType;
  resourceId: number;
  resourceName: number;
};

export type JiraissueLinkProps = {
  issueUrl: string;
  taskId: number;
};
